/* unplugin-vue-components disabled */import { render } from "./avatar-uploader.vue?vue&type=template&id=18a22651&scoped=true"
import script from "./avatar-uploader.vue?vue&type=script&lang=js"
export * from "./avatar-uploader.vue?vue&type=script&lang=js"

import "./avatar-uploader.vue?vue&type=style&index=0&id=18a22651&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a22651"],['__file',"src/components/uploader/avatar-uploader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18a22651"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18a22651', __exports__)) {
    api.reload('18a22651', __exports__)
  }
  
  module.hot.accept("./avatar-uploader.vue?vue&type=template&id=18a22651&scoped=true", () => {
    api.rerender('18a22651', render)
  })

}


export default __exports__